module.exports = __webpack_public_path__ + "media/images/pages/fcr-case/case-1-8acbfad5d19c1c90733722dd84ca99d4.png";